<script setup lang="ts">
import { computed } from "vue";

// The ⓘ glyph shared by InfoIcon (hover hint) and InfoModalButton (click to open docs). Kept as its own
// piece so splitting those two apart did not fork the icon into two copies that could drift.

const props = withDefaults(defineProps<{ inverted?: boolean }>(), { inverted: false });

const iconClasses = computed(() =>
  props.inverted
    ? "inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-400 text-white hover:bg-slate-500 dark:hover:bg-slate-450"
    : "inline-flex h-4 w-4 items-center justify-center rounded-full border border-slate-400 text-slate-400 hover:bg-slate-400 hover:text-white"
);
</script>

<template>
  <span :class="iconClasses">
    <svg
      class="h-4 w-4 scale-[1.2]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      fill="currentColor"
      aria-hidden="true">
      <path
        d="M288 224C288 206.3 302.3 192 320 192C337.7 192 352 206.3 352 224C352 241.7 337.7 256 320 256C302.3 256 288 241.7 288 224z
           M280 288L328 288C341.3 288 352 298.7 352 312L352 400L360 400C373.3 400 384 410.7 384 424C384 437.3 373.3 448 360 448L280 448C266.7 448 256 437.3 256 424C256 410.7 266.7 400 280 400L304 400L304 336L280 336C266.7 336 256 325.3 256 312C256 298.7 266.7 288 280 288z" />
    </svg>
  </span>
</template>
